/* eslint-disable max-classes-per-file */

import { ProductTypeEnums } from "@/types/product/account/history";

enum ProductTypeTransactionEnums {
  HOTEL = "hotels",
  FLIGHT = "flight",
  EXPERIENCE = "experience",
  EVENT = "events",
  CAR = "car",
}
export interface RequestBookingTransactionDataInterface {
  bookingInternalNo: string;
}

class TransactionData {
  id: string;

  paymentStatus: string;

  email: string;

  product_type: string;

  is_addons_status: boolean;

  isPaylater: boolean;

  historyDetailPath: string;

  constructor(data: any) {
    this.id = data?.id || "";
    this.paymentStatus = data?.paymentStatus || "";
    this.email = data?.email || "";
    this.product_type = data?.product_type || "";
    this.is_addons_status = data?.is_addons_status || false;
    this.isPaylater = data?.isPaylater || false;

    const handleHistoryDetailPath = () => {
      switch (this.product_type.toLocaleLowerCase()) {
        case ProductTypeTransactionEnums.HOTEL:
          return `/${ProductTypeEnums.HOTEL}`;

        case ProductTypeTransactionEnums.FLIGHT:
          return `/${ProductTypeEnums.FLIGHT}`;

        case ProductTypeTransactionEnums.EVENT:
        case ProductTypeTransactionEnums.EXPERIENCE:
          return `/${ProductTypeEnums.EXPERIENCE}`;

        case ProductTypeTransactionEnums.CAR:
          return `/${ProductTypeEnums.CARRENTAL}`;

        default:
          return "";
      }
    };

    this.historyDetailPath = handleHistoryDetailPath();
  }
}

export class ResponseBookingTransactionData {
  status: boolean;

  data: TransactionData;

  message: string;

  constructor(data: any) {
    this.status = data?.status || false;
    this.data = new TransactionData(data?.data);
    this.message = data?.message || "";
  }
}
